<template>
    <div class="event-info">
        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <span :class="{
                    'event-info__level--red': event.eventClassification === 4,
                    'event-info__level--yellow': event.eventClassification === 3,
                    'event-info__level--green': event.eventClassification === 2,
                }"
                v-bind="attrs"
                v-on="on"
                @click="showEvent"
                >{{ eventName(event.eventTypes[0]) }}<icon icon="go-to" class="event-info__icon"></icon>
                </span>
                </template>
            <span>Show event</span>
        </v-tooltip>
        <br />
        <strong>Time:</strong> {{ formatDate }}<br />
        <strong>Speed:</strong> {{ formatSpeedUnit }}<br />
        <strong>Speed Limit:</strong> {{ formatSpeedLimitUnit }}<br />
        <strong>Address:</strong> {{ address }}<br />
    </div>
</template>

<script>
import { calculateSpeedOrDistanceUnit, formatDate } from '@/helpers/Utils'
import Icon from '@/components/atoms/Icon'
import store from '../../store'

export default {
    name: 'EventInfoBubble',
    components: {
        Icon
    },
    props: {
        event: {
            type: Object,
            required: true
        },
        eventTypes: {
            type: Array,
            required: true
        },
        getSpeedUnit: {
            type: Number,
            required: true
        }
    },
    computed: {
        formatDate () {
            return formatDate(this.event.triggerOn)
        },
        formatSpeedUnit () {
            return 0 === this.getSpeedUnit ? this.event.speed + ' kph' : calculateSpeedOrDistanceUnit(this.event.speed, 'mi') + ' mph'
        },
        formatSpeedLimitUnit () {
            return 0 === this.getSpeedUnit ? this.event.speedLimit + ' kph' : calculateSpeedOrDistanceUnit(this.event.speedLimit, 'mi') + ' mph'
        },
        address () {
            if (null === this.event.address) {
                return 'Unknown'
            }

            return this.event.address.label || 'Unknown'
        }
    },
    methods: {
        eventName (value) {
            const event = this.eventTypes.find((elem) => {
                return elem.id === value
            })

            return event.key || 'Unknown'
        },
        showEvent () {
            const payload = { eventId: this.event.id, hardwareId: this.event.hardwareId }
            store.commit('setEventId', payload)
        }
    }
}
</script>

<style scoped lang="scss">
.event-info {
    padding: 10px 20px;
    min-width: 260px;

    &__level {
        font-weight: bold;

        &--red {
            color: $danger;
            cursor: pointer;
            transition: opacity 0.3s;

            &:hover {
                opacity: 0.5;
            }
        }

        &--yellow {
            color: #FDBF5E;
            cursor: pointer;
            transition: opacity 0.3s;

            &:hover {
                opacity: 0.5;
            }
        }

        &--green {
            color: #09B66D;
            cursor: pointer;
            transition: opacity 0.3s;

            &:hover {
                opacity: 0.5;
            }
        }
    }

    &__icon {
        margin-left: 6px;
        margin-top: -4px;
        width: 14px;
        height: 14px;
    }
}

</style>
